export const INCLUSO_ABN = "74 673 015 328"
export const INCLUSO_PHONE = "1300 674 401"
export const INCLUSO_EMAIL = "info@incluso.com.au"
export const INCLUSO_CAREER_EMAIL = "careers@incluso.com.au"

export const INCLUSO_FACEBOOK = "https://www.facebook.com/inclusoservices"
export const INCLUSO_LINKEDIN = "https://www.linkedin.com/company/incluso-services/"
export const INCLUSO_INSTAGRAM = "https://www.instagram.com/incluso_services"

// export const INCLUSO_HUBSPOT_DISCOVERY_CALENDAR = "https://meetings.hubspot.com/hannah-chasen?embed=true"
export const INCLUSO_HUBSPOT_DISCOVERY_CALENDAR = "https://meetings-ap1.hubspot.com/kellie-carruthers?embed=true"

// SEO
export const INCLUSO_WEBSITE_NAME = "Incluso Services"
export const INCLUSO_WEBSITE_URL = "https://www.incluso.com.au"
